import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "message-contents-field" }
const _hoisted_2 = {
  class: "is-size-7 m-bottom-12",
  "data-cy": "external-message-editor-footnote"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "notification is-warning footer" }, " Requester email not available - posts to timeline only. The requester will only be able to see your message if they contact your agency to have their email associated with this request. ", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!
  const _component_nr_editor = _resolveComponent("nr-editor")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_message_box = _resolveComponent("message-box")!

  return (_ctx.displayMsgBox && _ctx.currentAction === 'envelope')
    ? (_openBlock(), _createBlock(_component_message_box, {
        key: 0,
        title: $options.modalTitle,
        "submit-text": "Send external message",
        type: "green",
        "disable-submit": $options.disableSubmitMsg(),
        onOnClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setDisplayMsgBox(false))),
        onOnCancel: $options.handleCancelMessage,
        onOnSubmit: $options.handleSubmitMessage
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            ($options.canReadStaffOnlyItems)
              ? (_openBlock(), _createBlock(_component_NrSelect, {
                  key: 0,
                  modelValue: $data.selectedMessageTemplates,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedMessageTemplates) = $event)),
                  placeholder: "Search and select message template(s)",
                  options: $options.filteredMessageTemplates,
                  filterable: false,
                  loading: _ctx.dataFetchState.message_templates.fetching,
                  hasMore: !_ctx.dataFetchState.message_templates.end,
                  "onOption:deselected": _cache[1] || (_cache[1] = ($event: any) => ($options.setMessageTemplate(true, $event))),
                  "onOption:selected": _cache[2] || (_cache[2] = ($event: any) => ($options.setMessageTemplate(false, $event))),
                  onOpen: $options.searchMessageTemplates,
                  onSearch: $options.searchMessageTemplates,
                  onLoadMore: $options.loadMoreMessageTemplates,
                  class: "m-top-12",
                  multiple: ""
                }, {
                  label: _withCtx(() => [
                    _createTextVNode("Message Template")
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "loading", "hasMore", "onOpen", "onSearch", "onLoadMore"]))
              : _createCommentVNode("", true),
            _createVNode(_component_NrFormLabel, null, {
              default: _withCtx(() => [
                _createTextVNode("Message contents")
              ]),
              _: 1
            }),
            _createVNode(_component_nr_editor, {
              modelValue: $data.message,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.message) = $event)),
              resizable: false,
              placeholder: 
          $options.canReadStaffOnlyItems
            ? 'Type your message here or select a template above.'
            : 'Type your message here.'
        ,
              rows: 12,
              strike: "",
              bulletList: "",
              orderedList: "",
              link: ""
            }, null, 8, ["modelValue", "placeholder"]),
            _createElementVNode("p", _hoisted_2, [
              (this.canReadStaffOnlyItems && this.requesterEmailAvailable)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " This message will be visible to the requester and staff. "))
                : (
            this.canReadStaffOnlyItems && !this.requesterEmailAvailable
          )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, " Your message will be sent to staff working on this request and posted to the request timeline. "))
            ]),
            ($options.canReadStaffOnlyItems && $options.requesterEmailAvailable)
              ? (_openBlock(), _createBlock(_component_NrFormInput, {
                  key: 1,
                  modelValue: $data.messageRequired,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.messageRequired) = $event)),
                  id: "send-to-requester-checkbox",
                  type: "checkbox",
                  label: "Yes, send to requester (required)"
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["title", "disable-submit", "onOnCancel", "onOnSubmit"]))
    : _createCommentVNode("", true)
}